import { apiClient } from './client';
import type { AuthUser } from '../stores/auth.store';

export interface LoginResponse {
  accessToken: string;
  user: AuthUser;
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  const res = await apiClient.post<LoginResponse>('/auth/login', { email, password });
  return res.data;
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function getMe(): Promise<{ user: AuthUser }> {
  const res = await apiClient.get<{ user: AuthUser }>('/auth/me');
  return res.data;
}

export async function refreshSession(): Promise<LoginResponse> {
  const res = await apiClient.post<LoginResponse>('/auth/refresh');
  return res.data;
}
